var _defs, _polygon, _path, _rect, _polygon2, _path2, _path3, _path4, _path5, _path6, _rect2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEsrbRp17Plus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 46.34 69.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#231f20;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.34 0 45.67 0 0.67 0 0 0 0 0.75 0 68.77 0 69.51 0.67 69.51 45.67 69.51 46.34 69.51 46.34 68.77 46.34 0.75 46.34 0 46.34 0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.73,44.85v68h-45v-68h45",
    transform: "translate(-61.06 -44.1)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.9,
    y: 14.18,
    width: 40.17,
    height: 44.19
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2.93 66.32 2.93 60.81 10.99 60.81 10.99 62.1 6.17 62.1 6.17 62.89 10.25 62.89 10.25 64.17 6.17 64.17 6.17 65.03 11.18 65.03 11.18 66.32 2.93 66.32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.09,106.52a.61.61,0,0,0-.47-.38,3,3,0,0,0-.84-.1c-.71,0-1,.12-1,.32,0,.82,5.69.31,5.69,2.31,0,1.27-1.91,1.9-4.63,1.9s-4.31-.85-4.38-1.85h3.1a.8.8,0,0,0,.54.44,3,3,0,0,0,.92.14c.81,0,1.35-.15,1.35-.41,0-.83-5.69-.26-5.69-2.36,0-1.17,1.81-1.75,4.29-1.75,2.74,0,4,.77,4.23,1.74Z",
    transform: "translate(-61.06 -44.1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.29,107.3h1.27c1,0,1.54-.14,1.54-.52s-.55-.58-1.3-.58H87.29Zm0,1.2v1.92H84.05v-5.51h4.67c3.29,0,4.38.51,4.38,1.58,0,.63-.51,1.16-1.66,1.35,1,.21,1.67.34,1.67,1.45,0,.71,0,1,.34,1v.17H90.17a2.16,2.16,0,0,1-.16-1c0-.73-.22-1-1.73-1Z",
    transform: "translate(-61.06 -44.1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.32,106.2v.92h1.36c.64,0,1.11-.16,1.11-.48s-.64-.44-1.32-.44Zm0,1.92v1h1.42c.8,0,1.4-.09,1.4-.5s-.75-.51-1.78-.51Zm-3.23,2.3v-5.51h4.72c2.23,0,4,.3,4,1.39,0,.57-.66,1-1.29,1.2,1.07.15,1.64.67,1.64,1.26,0,1.23-1.68,1.66-4.25,1.66Z",
    transform: "translate(-61.06 -44.1)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.58,81.37c-.67-2.48-2-3.94-3.89-4.44,1.18-1.38,1.85-3.52.94-6.87-1.27-4.68-4.48-6.94-8.4-5.9l-8.9,2.36-.18,0,7.37,27.27,6-1.59s-2.42-8.93-2.84-10.5l.29-.08a2.76,2.76,0,0,1,2,0c.78.45,1.15,1.81,1.57,3.39l.33,1.26a11.75,11.75,0,0,0,1.82,4.42l.4.53,6.81-1.8L88,88.33A38.83,38.83,0,0,1,85.58,81.37Zm-9.74-4.88-1.52.41c-.44-1.65-1.46-5.43-1.9-7.07l1.51-.4c.72-.19,1.93-.51,2.81,2.75C76.91,72.82,77.67,76,75.84,76.49Z",
    transform: "translate(-61.06 -44.1)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93,59.63l-8,2.13-1,.25,7.37,27.27,6.08-1.61s-2.37-8.76-2.79-10.33l2.61-.69c4.75-1.27,6.56-5,5.1-10.36C100.52,59.23,96.27,58.77,93,59.63Zm2.48,12.1-2.16.58c-.44-1.62-1.48-5.45-1.91-7.07l1.85-.49c1-.28,2.24-.28,3.19,3.24C97,69.66,96.47,71.48,95.52,71.73Z",
    transform: "translate(-61.06 -44.1)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.91,
    y: 2.75,
    width: 40.14,
    height: 9.63
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.94,54.88h-.8V48.47h1.48a.72.72,0,0,1,.65.43,2.59,2.59,0,0,1,.24,1.25,2.92,2.92,0,0,1-.16,1,.81.81,0,0,1-.55.53v0a.83.83,0,0,1,.18,0,.48.48,0,0,1,.23.16,1,1,0,0,1,.2.37,2,2,0,0,1,.09.68v.42c0,.18,0,.37,0,.57s0,.37,0,.54a1.66,1.66,0,0,0,0,.35H66.8a2.51,2.51,0,0,1-.08-.62V53.09a1.8,1.8,0,0,0-.06-.44.58.58,0,0,0-.17-.31.45.45,0,0,0-.34-.12h-.21Zm0-3.64h.35a.25.25,0,0,0,.2-.09.63.63,0,0,0,.13-.23,1.33,1.33,0,0,0,.06-.3,1.77,1.77,0,0,0,0-.32,1.28,1.28,0,0,0-.11-.65.32.32,0,0,0-.3-.19h-.35Z",
    transform: "translate(-61.06 -44.1)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.81,54.88l1.06-6.41h1l1,6.41h-.84l-.21-1.42H68.82l-.22,1.42Zm1.54-5.18h0L69,52.47h.76Z",
    transform: "translate(-61.06 -44.1)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.3,48.47v1.07h-.89v5.34h-.8V49.54h-.89V48.47Z",
    transform: "translate(-61.06 -44.1)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.67,54.88V48.47h.8v6.41Z",
    transform: "translate(-61.06 -44.1)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.15,54.88V48.47h1.08l1,4.44h0V48.47H78v6.41H77l-1-4.69h0v4.69Z",
    transform: "translate(-61.06 -44.1)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.43,50.44c0-.15,0-.29,0-.42a1.21,1.21,0,0,0-.07-.36.57.57,0,0,0-.14-.24.34.34,0,0,0-.26-.1.31.31,0,0,0-.28.2,1.54,1.54,0,0,0-.15.52,7.58,7.58,0,0,0-.06.76c0,.29,0,.58,0,.89,0,.5,0,.91,0,1.22a4.64,4.64,0,0,0,.09.71.57.57,0,0,0,.18.34.41.41,0,0,0,.28.09l.2,0,.2-.09V52.51H80v-1h1.24v3.25l-.22.06-.29.07a2.84,2.84,0,0,1-.31.06l-.27,0a1.55,1.55,0,0,1-.8-.18,1.1,1.1,0,0,1-.45-.59,3.68,3.68,0,0,1-.2-1c0-.42,0-.94,0-1.55,0-.4,0-.8,0-1.19a4.46,4.46,0,0,1,.16-1,1.66,1.66,0,0,1,.41-.74,1,1,0,0,1,.76-.29,1,1,0,0,1,.53.14,1.18,1.18,0,0,1,.4.4,2.15,2.15,0,0,1,.23.65,3.49,3.49,0,0,1,.07.89Z",
    transform: "translate(-61.06 -44.1)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.1,48.47h1.44a.87.87,0,0,1,.47.13,1,1,0,0,1,.32.39,2.32,2.32,0,0,1,.18.61,6.18,6.18,0,0,1,0,.79q0,.27,0,.6a2.37,2.37,0,0,1-.15.61,1.23,1.23,0,0,1-.32.48.84.84,0,0,1-.56.19h-.6v2.61h-.8Zm.8,2.81h.45a.21.21,0,0,0,.16-.07.77.77,0,0,0,.13-.2,1.55,1.55,0,0,0,.11-.59c0-.13,0-.25,0-.37a.94.94,0,0,0-.07-.31.46.46,0,0,0-.14-.21.31.31,0,0,0-.22-.07h-.4Z",
    transform: "translate(-61.06 -44.1)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86,54.88V48.47h2.09v1H86.84V51H88v1H86.84v1.87h1.33v1Z",
    transform: "translate(-61.06 -44.1)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.7,54.88V48.47h1.08l1,4.44h0V48.47h.74v6.41h-1l-1-4.69h0v4.69Z",
    transform: "translate(-61.06 -44.1)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.24,48.47h1.34a1,1,0,0,1,.64.21,1.43,1.43,0,0,1,.37.63,4.14,4.14,0,0,1,.19,1c0,.4,0,.84,0,1.34v.58q0,.33,0,.69a5.43,5.43,0,0,1-.1.72,2.91,2.91,0,0,1-.21.63,1.25,1.25,0,0,1-.38.44.87.87,0,0,1-.56.18H92.24Zm.8,5.42h.39a.41.41,0,0,0,.3-.12.9.9,0,0,0,.17-.38A4.88,4.88,0,0,0,94,52.7c0-.28,0-.62,0-1v-.84a4.88,4.88,0,0,0-.07-.71,1.35,1.35,0,0,0-.16-.48.37.37,0,0,0-.32-.18H93Z",
    transform: "translate(-61.06 -44.1)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.47,54.88V48.47h.8v6.41Z",
    transform: "translate(-61.06 -44.1)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97,54.88V48.47H98l1,4.44h0V48.47h.74v6.41h-1l-1-4.69h0v4.69Z",
    transform: "translate(-61.06 -44.1)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.23,50.44c0-.15,0-.29,0-.42a1.68,1.68,0,0,0-.06-.36.58.58,0,0,0-.15-.24.33.33,0,0,0-.54.1,1.54,1.54,0,0,0-.15.52,5.58,5.58,0,0,0,0,.76c0,.29,0,.58,0,.89,0,.5,0,.91,0,1.22a3,3,0,0,0,.09.71.63.63,0,0,0,.17.34.45.45,0,0,0,.28.09l.21,0,.19-.09V52.51h-.44v-1H103v3.25l-.21.06-.29.07-.31.06-.27,0a1.53,1.53,0,0,1-.8-.18,1.12,1.12,0,0,1-.46-.59,3.68,3.68,0,0,1-.2-1c0-.42,0-.94,0-1.55,0-.4,0-.8,0-1.19a4.46,4.46,0,0,1,.16-1,1.65,1.65,0,0,1,.4-.74,1.11,1.11,0,0,1,1.29-.15,1.18,1.18,0,0,1,.4.4,1.91,1.91,0,0,1,.24.65,4.06,4.06,0,0,1,.06.89Z",
    transform: "translate(-61.06 -44.1)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.15,101.27V95h.72v5.2h1.06v1Z",
    transform: "translate(-61.06 -44.1)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.25,101.27V95H68v6.23Z",
    transform: "translate(-61.06 -44.1)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.07,95h.79l-1,2.8,1,3.43h-.8l-.82-3.19h0v3.19h-.71V95h.71v2.67h0Z",
    transform: "translate(-61.06 -44.1)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.18,101.27V95H73v1H71.9v1.53h1v1h-1v1.82h1.18v1Z",
    transform: "translate(-61.06 -44.1)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.55,101.27V95h.71v5.2h1.07v1Z",
    transform: "translate(-61.06 -44.1)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.92,99.11,75,95h.78l.51,2.63L76.86,95h.73l-1,4.07v2.16h-.71Z",
    transform: "translate(-61.06 -44.1)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79,101.27V95H80.1l.53,4.24h0L81.21,95h1.11v6.23h-.7V96.46h0L81,101.27h-.68l-.63-4.81h0v4.81Z",
    transform: "translate(-61.06 -44.1)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.64,101.27,83.58,95h.94l.93,6.23H84.7l-.19-1.38h-1l-.2,1.38Zm1.37-5h0l-.32,2.69h.68Z",
    transform: "translate(-61.06 -44.1)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.53,95v1h-.79v5.2H86v-5.2h-.79V95Z",
    transform: "translate(-61.06 -44.1)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.17,95v4.42a4,4,0,0,1-.06.7,2.3,2.3,0,0,1-.2.61,1.29,1.29,0,0,1-.35.44.9.9,0,0,1-.55.17,1,1,0,0,1-.88-.52,2.92,2.92,0,0,1-.28-1.4V95h.71v4.33a2.07,2.07,0,0,0,.12.83.36.36,0,0,0,.32.24.35.35,0,0,0,.34-.27,2.13,2.13,0,0,0,.11-.8V95Z",
    transform: "translate(-61.06 -44.1)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.45,101.27h-.72V95h1.32a.63.63,0,0,1,.58.41,2.63,2.63,0,0,1,.22,1.22,3,3,0,0,1-.15,1,.72.72,0,0,1-.48.52v0l.16,0a.44.44,0,0,1,.2.15,1,1,0,0,1,.18.36,2.33,2.33,0,0,1,.07.66c0,.1,0,.24,0,.42s0,.36,0,.55,0,.37,0,.53,0,.27,0,.33h-.69a2.33,2.33,0,0,1-.08-.59V99.54a1.84,1.84,0,0,0,0-.44.71.71,0,0,0-.15-.3.42.42,0,0,0-.31-.11h-.18Zm0-3.54h.31a.25.25,0,0,0,.18-.08,1.13,1.13,0,0,0,.11-.22,1.33,1.33,0,0,0,.06-.3c0-.11,0-.22,0-.31a1.56,1.56,0,0,0-.1-.64.3.3,0,0,0-.27-.18h-.31Z",
    transform: "translate(-61.06 -44.1)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.37,101.27V95h1.86v1H94.09v1.53h1v1h-1v1.82h1.18v1Z",
    transform: "translate(-61.06 -44.1)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.72,96.18a3.53,3.53,0,0,0,.34-.41,2.42,2.42,0,0,0,.29-.53H98v6h-.72V96.63A2.07,2.07,0,0,1,97,97c-.09.11-.19.21-.28.31Z",
    transform: "translate(-61.06 -44.1)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.5,96.39l-.8,4.88H99l.91-5.09H98.73v-.94h1.77Z",
    transform: "translate(-61.06 -44.1)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.6,96.91h.52v1.7h.8v1h-.8v1.7h-.52v-1.7h-.81v-1h.81Z",
    transform: "translate(-61.06 -44.1)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsrbRp17Plus);
export default __webpack_public_path__ + "static/media/esrb-rp17plus.dd71bbf09278268bc7b3d1216457b2fe.svg";
export { ForwardRef as ReactComponent };